import React from 'react';
import InvoiceSearch from './InvoiceSearch';
import InvoiceList from './InvoiceList';
import InvoicePayments from './InvoicePayments';
import InvoiceThankYou from './InvoiceThankYou';
import {
    addResourceStrings,
    translateResourceString
} from '../util/translationUtility';
import {
    MessagesList,
    ERROR_USER_ALERT,
} from '../SharedComponents/UserMessaging/';
import { fetchAccountOrganizationOptions } from "./SharedServiceCalls"

let messageId = 0;
const createUserMessage = ({ text, type }) => ({ id: messageId++, text, type });

class InvoicePaymentsApp extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeView: 0,
            accountOrganizationOptions: [],
            selectedAccountOrganizationOption: null,
            allInvoices: [],
            userMessages: [],
            newInvoicePayment: null,
            newInvoicePaymentType: null
        };

        addResourceStrings(props.LocalizationItems);
    }

    async componentDidMount() {
        var accountsAndOrganizationsResponse = await fetchAccountOrganizationOptions(this.props.GetAccountsAndOrganizationsOptionsEndpoint);
        if (accountsAndOrganizationsResponse.success) {
            this.setState( { accountOrganizationOptions: accountsAndOrganizationsResponse.options,
                                  selectedAccountOrganizationOption: accountsAndOrganizationsResponse.options.length > 0 ? accountsAndOrganizationsResponse.options[0] : null});
        } else {
            if (accountsAndOrganizationsResponse.message) {
                this.addMessage(accountsAndOrganizationsResponse.message);
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedAccountOrganizationOption !== this.state.selectedAccountOrganizationOption) {
            if (!!this.state.selectedAccountOrganizationOption) {
                this.fetchInvoices(this.state.selectedAccountOrganizationOption);
            } else {
                this.setState({ allInvoices: [] });
            }
        }
    }

    fetchInvoices = (option) => {
        var fetchUrl = this.props.GetOpenARForAccountEndpoint + "?accountId=" + option.AccountId;
        if (!option.AccountId) {
            fetchUrl = this.props.GetOpenARForOrganizationEndpoint + "?organizationId=" + option.OrganizationId;
        }

        fetch(
            fetchUrl,
            {
                headers: {
                    'content-type': 'application/json',
                    'X-Requested-With': 'fetch'
                },
                credentials: 'same-origin',
            }
        )
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    if (typeof console !== 'undefined' && console.log) {
                        console.error(response);
                    }
                    throw new Error()
                }
            })
            .then(data => {
                if (!data || !data.invoices) {
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(data);
                    }
                    throw new Error("Invalid data format");
                }
                this.setState(prevState => {
                    for (let i = 0; i < data.invoices.length; i++) {
                        data.invoices[i].isSelected = false;
                        data.invoices[i].amountToPay = 0;
                    }
                    return { allInvoices: data.invoices };
                });
            })
            .catch(() => {
                this.setState(prevState => ({
                    userMessages: prevState.userMessages.concat([
                        createUserMessage({
                            text: translateResourceString("/MyAccountPage/InvoicePayments/ErrorLoadingInvoices"),
                            type: ERROR_USER_ALERT
                        })
                    ])
                }));
            });
    }

    setInvoiceSelected = (invoiceId, isSelected) => {
        this.setState((prevState) => {
            let invoicesCopy = [...prevState.allInvoices];
            let index = invoicesCopy.findIndex(inv => inv.OpenARId === invoiceId);
            let amountToPay = invoicesCopy[index].Balance;
            //if (isSelected && invoicesCopy[index].Balance < 0) {
            //    const selectedInvoices = invoicesCopy.filter((inv) => inv.isSelected)
            //    var selectedInvoiceTotal = this.getSelectedInvoiceTotal(selectedInvoices);
            //    amountToPay = -Math.min(Math.abs(invoicesCopy[index].Balance), selectedInvoiceTotal);
            //}
            invoicesCopy[index].isSelected = isSelected;
            invoicesCopy[index].amountToPay = isSelected ? amountToPay.toFixed(2) : null;

            return {
                allInvoices: invoicesCopy
            };
        });
    }

    setInvoiceAmountToPay = (invoiceId, amount) => {
        this.setState((prevState) => {
            let invoicesCopy = [...prevState.allInvoices];
            let index = invoicesCopy.findIndex(inv => inv.OpenARId === invoiceId);
            invoicesCopy[index].amountToPay = amount;

            return {
                allInvoices: invoicesCopy
            };
        });
    }

    // 0 = Search, 1 = Payment, 2 = Thank You
    navigateToView = (viewIndex) => {
        var prevView = this.state.activeView;
        this.setState({ activeView: viewIndex });
        this.clearMessages();
        if (prevView === 2) {
            this.setState({ allInvoices: [] });
            this.fetchInvoices(this.state.selectedAccountOrganizationOption);
        }
    }

    onDismissMessage = (id) => {
        this.setState(prevState => ({
            userMessages: prevState.userMessages
                ? prevState.userMessages.filter((message) => message.id !== id)
                : []
        }));
    }

    clearMessages = () => {
        this.setState({ userMessages: [] });
    }

    getSelectedInvoiceTotal = (selectedInvoices) => {
        let selectedInvoiceTotal = 0;
        for (let i = 0; i < selectedInvoices.length; i++) {
            if (selectedInvoices[i].Balance > 0) {
                selectedInvoiceTotal += Math.abs(selectedInvoices[i].amountToPay);
            } else {
                selectedInvoiceTotal -= Math.abs(selectedInvoices[i].amountToPay);
            }
        }
        if (Math.abs(selectedInvoiceTotal) < .005) return 0;

        return selectedInvoiceTotal;
    }

    addMessage = ({ text, type }) => {
        this.setState(prevState => ({
            userMessages: prevState.userMessages.concat([
                createUserMessage({
                    text: text,
                    type: type
                })
            ])
        }))
    };

    setAndViewNewInvoicePayment = (newInvoicePayment, newInvoicePaymentType) => {
        this.setState({
            newInvoicePayment: newInvoicePayment,
            activeView: 2,
            newInvoicePaymentType: newInvoicePaymentType
        });
    }

    render() {
        const {
            activeView,
            allInvoices,
            accountOrganizationOptions,
            selectedAccountOrganizationOption,
            userMessages,
            newInvoicePayment,
            newInvoicePaymentType
        } = this.state;
        const {
            BraintreeClientSettings,
            BraintreeClientTokenEndpoint,
            BraintreeUsBankAccountEndpoint,
            CreditCardSurchargePercentage,
            PayInvoicesEndpoint,
            ContactUsUrl,
            StartPageUrl,
            States,
            UsTwoLetterCountryCode,
            UsThreeLetterCountryCode,
            PaymentButtonText
        } = this.props;

        const selectedInvoices = allInvoices.filter((inv) => inv.isSelected);

        const selectedInvoiceTotal = this.getSelectedInvoiceTotal(selectedInvoices);

        return (
            <React.Fragment>
                <MessagesList
                    messages={userMessages}
                    onDismiss={this.onDismissMessage}
                />
                {activeView === 0 &&
                    <React.Fragment>
                        <p dangerouslySetInnerHTML={{
                            __html: translateResourceString("/MyAccountPage/InvoicePayments/PartialPaymentsMessage",
                                `<a href="${ContactUsUrl}">${translateResourceString("/MyAccountPage/InvoicePayments/PartialPaymentsMessageLink")}</a>`)
                        }} />
                        <InvoiceSearch
                            accountOrganizationOptions={accountOrganizationOptions}
                            selectedAccountOrganizationOption={selectedAccountOrganizationOption}
                            setSelectedAccountOrganization={(option) => { this.setState({ selectedAccountOrganizationOption: option }); }}
                        />
                        <InvoiceList
                            invoices={allInvoices}
                            invoicesTotal={selectedInvoiceTotal}
                            setInvoiceSelected={this.setInvoiceSelected}
                            setInvoiceAmountToPay={this.setInvoiceAmountToPay}
                            navigateToView={this.navigateToView}
                            useSummaryView={false}
                        />
                    </React.Fragment>
                }
                {activeView === 1 &&
                    <InvoicePayments
                        selectedInvoices={selectedInvoices}
                        selectedAccountOrganizationOption={selectedAccountOrganizationOption}
                        invoicesTotal={selectedInvoiceTotal}
                        navigateToView={this.navigateToView}
                        billToAddress={''}
                        payInvoicesEndpoint={PayInvoicesEndpoint}
                        onSuccessfulInvoicePayment={''}
                        braintreeClientSettings={BraintreeClientSettings}
                        addMessage={this.addMessage}
                        clearMessages={this.clearMessages}
                        braintreeClientTokenEndpoint={BraintreeClientTokenEndpoint}
                        setAndViewNewInvoicePayment={this.setAndViewNewInvoicePayment}
                        braintreeUsBankAccountEndpoint={BraintreeUsBankAccountEndpoint}
                        creditCardSurchargePercentage={CreditCardSurchargePercentage}
                        states={States}
                        usTwoLetterCountryCode={UsTwoLetterCountryCode}
                        usThreeLetterCountryCode={UsThreeLetterCountryCode}
                        paymentButtonText={PaymentButtonText}
                    />}
                {activeView === 2 &&
                    <InvoiceThankYou
                        invoicePayment={newInvoicePayment}
                        selectedAccountOrganizationOption={selectedAccountOrganizationOption}
                        contactUsUrl={ContactUsUrl}
                        startPageUrl={StartPageUrl}
                        navigateToView={this.navigateToView}
                        invoicePaymentType={newInvoicePaymentType}
                    />
                }
            </React.Fragment>
        );
    }
}

export default InvoicePaymentsApp;